import styled, { css } from 'styled-components';

const styles = theme => ({
  cardDetail: {
    alignItems: 'flex-start',
    display: 'flex',
    paddingTop: 20,
    '@media(max-width: 710px)': {
      display: 'block',
    },
  },
  cardDetailItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 30px',
    '@media(max-width: 710px)': {
      flexDirection: 'column',
      padding: 0,
      width: 'auto',
    },
  },
  cardDetailItemWrapper1: {
    borderRight: `1px dashed ${theme.color.mystic}`,
    flexDirection: 'column',
    width: '190px',
    '@media(max-width: 710px)': {
      borderRight: 0,
    },
  },
  cardDetailItemWrapper2: {
    borderRight: `1px dashed ${theme.color.mystic}`,
    flex: 1,
    flexDirection: 'column',
    '@media(max-width: 710px)': {
      borderBottom: `1px dashed ${theme.color.mystic}`,
      borderRight: 0,
      borderTop: `1px dashed ${theme.color.mystic}`,
      marginBottom: 15,
      paddingTop: 15,
      '&:first-child': {
        borderBottom: 'none',
        borderTop: 'none',
        marginBottom: 0,
        paddingTop: 0,
      },
    },
  },
  cardDetailItemWrapper3: {
    justifyContent: 'space-between',
    width: '310px',
  },
  cardDetailItem: {
    marginBottom: 15,
  },
  cardDetailItemColumn3: {
    width: '120px',
  },
  cardDetailTitle: {
    color: theme.color.regentGray,
    display: 'block',
    fontSize: 12,
    marginBottom: 5,
  },
  cardDetailValue: {
    color: theme.color.tundora,
    display: 'block',
    fontSize: 14,
    lineHeight: '18px',
  },
  cardDetailNoBorder: {
    borderRight: 'none',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 6,
    width: '100%',
  },
  backupInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingBottom: 25,

    '@media(max-width: 710px)': {
      flexDirection: 'column',
      padding: 0,
      width: 'auto',
    },
  },
  productInfo: {
    display: 'flex',
  },
  backupDescription: {
    color: theme.color.tundora,
    fontSize: 14,
    fontWeight: '400',
    margin: 0,
    paddingBottom: 17,
  },
});

export default styles;


export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 40px;
    flex-wrap: wrap;  

    @media(max-width: ${theme.v3.breakpoints.md}) {
      gap: 0px;
    }
  `}
`;

export const GatorProtectBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
`;

export const GatorProtectTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    display: flex;
    gap: 8px;
  `}
`;

export const ProBadge = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background: linear-gradient(90deg, #3094EF 0%, #02AEF2 20%, #2BC5EF 40%, #5CDAE9 60%, #8BEDE6 80%, #B9FFE8 100%);
    border-radius: 20px;
    color: ${theme.v3.colors.brand.snappyBlue[30]};
    display: flex;
    font-size: 10px;
    font-weight: ${theme.v3.font.weights.bold};
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    min-width: 34px;
    padding: 4px 6px;
  `}
`;

export const SeparatorH = styled.div`
  ${({ theme }) => css`
    border-top: 1px dashed ${theme.v3.colors.neutral[90]};
    margin: 40px 0px;
    width: 100$;

    @media(max-width: ${theme.v3.breakpoints.md}) {
      margin: 20px 0px;
      width: 100%;
    }
  `}
`;

export const SeparatorV = styled(SeparatorH)`
  ${({ theme }) => css`

    @media(min-width: ${theme.v3.breakpoints.md}) {
      border-top: 0px;
      margin: 0px !important;

      border-left: 1px dashed ${theme.v3.colors.neutral[90]};
      height: 100%;
    }
  `}
`;

export const GatorProtectFirstRow = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 8px 0px 0px;;
  `}
`;

export const GatorPRotectSecondRow = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 16px 0px 0px;
  `}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin: 16px 0px 0px;
`;
